module.exports = __webpack_public_path__ + "img/logo-safras-black.68c992f1.svg";